/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InitiateOutOfNetworkPaymentRequest} from '@cash-web/protos/squareup/cash/fiatly/api/v2beta/initiate_out_of_network_payment.pb'
import {InitiateOutOfNetworkPaymentResponse} from '@cash-web/protos/squareup/cash/fiatly/api/v2beta/initiate_out_of_network_payment.pb'


export const initiateOutOfNetworkPayment = (request: InitiateOutOfNetworkPaymentRequest, options?: CashRequestOptions) => post<InitiateOutOfNetworkPaymentRequest, InitiateOutOfNetworkPaymentResponse>("/2.0/cash/initiate-out-of-network-payment", request, {...options, rejectOnError: true })